import { render, staticRenderFns } from "./createLabelModal.vue?vue&type=template&id=230745a1&scoped=true"
import script from "./createLabelModal.vue?vue&type=script&lang=js"
export * from "./createLabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230745a1",
  null
  
)

export default component.exports